
































































































































import { Component, Prop, Vue, Inject } from "vue-property-decorator";

import ChangeDeliteButtons from "../../buttons/change-delite-buttons.vue";
import FullChannelCard from "./full-channel-card.vue";
import QuickChangeForm from "@/components/forms/quick-change-form.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import {
  channelType,
  channelTypes,
  polarizations,
  audioStreamTypes,
  rfBroadcastTypes,
  ipBroadcastTypes,
  videoStreamTypes,
} from "@/config/channels/channel-types.config.json";

import { IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";

@Component({
  components: {
    ChangeDeliteButtons,
    BSwitch,
    QuickChangeForm,
    FullChannelCard,
  },
})
export default class ChannelListTabs extends Vue {
  @Prop({ type: Object, default: null }) channel!: IChannel;
  @Prop({ type: Array, default: () => [] }) contentTypes!: Array<IContentType>;

  @Inject() readonly channel_images!: string;

  active = "";
  contentType = "";

  changeFrequency = false;
  changeProgramNumber = false;
  changeIP = false;
  changePort = false;

  editingSortOrder = false;
  editSortOrderValue = 0;
  editingLogicalNumber = false;
  editLogicalNumberValue = 0;

  pendingChanges: Record<string, unknown> | null = null;
  saveTimer: ReturnType<typeof setTimeout> | null = null;

  frequency = "";
  programNumber = "";
  ip = "";
  port = "";

  startEditSortOrder(): void {
    this.editSortOrderValue = this.channel.sort_order;
    this.editingSortOrder = true;
    this.$nextTick(() => {
      const input = this.$refs.sortOrderInput as HTMLInputElement;
      if (input) input.focus();
    });
  }

  saveSortOrder(): void {
    this.editingSortOrder = false;
    const val = Number(this.editSortOrderValue);
    if (val !== this.channel.sort_order) {
      this.queueChange("sort_order", val);
    }
  }

  startEditLogicalNumber(): void {
    this.editLogicalNumberValue = this.channel.logical_number_on_linked_tv ?? 0;
    this.editingLogicalNumber = true;
    this.$nextTick(() => {
      const input = this.$refs.logicalNumberInput as HTMLInputElement;
      if (input) input.focus();
    });
  }

  saveLogicalNumber(): void {
    this.editingLogicalNumber = false;
    const val = Number(this.editLogicalNumberValue);
    if (val !== (this.channel.logical_number_on_linked_tv ?? 0)) {
      this.queueChange("logical_number_on_linked_tv", val);
    }
  }

  queueChange(field: string, value: unknown): void {
    if (!this.pendingChanges) this.pendingChanges = {};
    this.pendingChanges[field] = value;
    if (this.saveTimer) clearTimeout(this.saveTimer);
    this.saveTimer = setTimeout(() => {
      if (this.pendingChanges) {
        this.$emit(
          "updateChannel",
          { ...this.pendingChanges },
          this.channel._id
        );
        this.pendingChanges = null;
      }
    }, 150);
  }

  onShowToggle(val: boolean): void {
    this.queueChange("show", val);
  }

  get broadcastType(): string {
    const type = channelType.find((t) => this.channel.data.channelType == t.id);
    return type ? type.name : "UNKNOWN";
  }

  get polarization(): string {
    const polarizatopn = polarizations.find(
      (p) => this.channel.data.polarization == p.id
    );
    return polarizatopn ? polarizatopn.name : "UNKNOWN";
  }

  get audioStreamType(): string {
    const ast = audioStreamTypes.find(
      (a) => this.channel.data.audioStreamType == a.id
    );
    return ast ? ast.name : "UNKNOWN";
  }

  get rfBroadcastType(): {
    name: string;
    abriviate: string;
  } {
    const res = rfBroadcastTypes.find(
      (rf) => this.channel.data.rfBroadcastType == rf.id
    );
    return res
      ? { name: res.name, abriviate: res.abriviate }
      : { name: "UNKNOWN", abriviate: "UNKNOWN" };
  }

  get ipBroadcastType(): string {
    const rea = ipBroadcastTypes.find(
      (t) => this.channel.data.ipBroadcastType == t.id
    );
    return rea ? rea.name : "UNKNOWN";
  }

  get videoStreamType(): string {
    const videoStreamType = videoStreamTypes.find(
      (t) => this.channel.data.videoStreamType == t.id
    );
    return videoStreamType ? videoStreamType.name : "UNKNOWN";
  }

  get type(): string {
    const type = channelTypes[this.channel.type - 1];
    return type ? type : "UNKNOWN";
  }
}
